/* eslint-disable import/no-extraneous-dependencies */
import Vue from 'vue';
import VueRouter from 'vue-router';
import VueTimeago from 'vue-timeago';
import Paginate from 'vuejs-paginate';
import VueLazyload from 'vue-lazyload';

import {
  Inputitems,
  Select,
  Input,
  Field,
  Config as OrugaConfig,
} from '@oruga-ui/oruga';

import store from './store/producer';
import ColorPickerComponent from './components/colorpicker/ColorPicker.vue';
import DropdownComponent from './shared/dropdown/Dropdown.vue';
import InputTagComponent from './shared/input-tag/InputTag.vue';

import SocketIO from './plugins/socket-io';
import Toasts from './plugins/toasts';

import '../sass/producer.scss';

window.jQuery = require('jquery');

window.$ = window.jQuery;

require('bootstrap');
require('./utils/filters'); // Referenced in child components

const LaunchDarkly = require('@tagboard/launchdarkly');
const instrument = require('./instrument');

// Expose this.$ld plugin
Vue.use(LaunchDarkly.vuePlugin({
  userApi: process.env.USER_API,
  clientId: process.env.LAUNCH_DARKLY_CLIENT_ID,
}));

Vue.use(VueRouter);

Vue.use(Inputitems);
Vue.use(Select);
Vue.use(Input);
Vue.use(Field);
Vue.use(OrugaConfig, {
  inputitems: {
    override: true,
    confirmKeys: [',', 'Tab', 'Enter', ' '],
    closable: true,
  },
  select: {
    iconPack: 'fa',
    iconRight: 'chevron-down',
    useHtml5Validation: true,
  },
  input: {
    useHtml5Validation: true,
  },
  iconPack: 'fas',
});

Vue.component('input-tag', InputTagComponent);
Vue.component('colorpicker', ColorPickerComponent);
Vue.component('paginate', Paginate);
Vue.component('dropdown', DropdownComponent);

// Replicate old school VueSocketIO plugin by registering all event listeners found in store actions.
Vue.use(SocketIO, { store });

// Setup global toast methods
Vue.use(Toasts);

Vue.use(VueTimeago, {
  name: 'Timeago',
  locale: 'en',
});

Vue.use(VueLazyload);

const routes = [
  {
    path: '/',
    component: () => import('./components/App.vue'),
    children: [
      {
        path: '',
        redirect: {
          name: 'productions',
          params: {
            tab: 'all',
          },
        },
      },
      {
        path: 'productions/:tab/:owner?',
        component: () => import('./components/manage-productions/ProducerDashboard.vue'),
        name: 'productions',
        props: (route) => ({ tab: route.params.tab || 'all' }),
      },
      {
        path: '404',
        component: () => import('./routes/404/404.vue'),
        name: '404',
      },
      {
        path: ':production_id',
        component: () => import('./routes/production/Production.vue'),
        name: 'production',
        children: [
          {
            // There used to be specific routes for each tab (e.g. /:production_id/graphics)
            // this will just catch all of those and redirect to the production route
            path: '*',
            redirect: {
              name: 'production',
            },
          },
        ],
      },
    ],
  },
];

const router = new VueRouter({
  routes,
});

instrument(Vue, router);

window.vm = new Vue({
  store,
  router,
}).$mount('#app');

window.addEventListener('message', (e) => {
  if (typeof e.data === 'string' && e.data.indexOf('tgbAssetManagerSelectedAsset') === 0) {
    const asset = JSON.parse(e.data.split('|')[1]);
    window.assetmanfn(asset);
  }
}, false);

window.addEventListener('unhandledrejection', (e) => {
  console.log('Unhandled Rejection:', e.reason); // eslint-disable-line no-console
});
